import { css } from 'styled-components';

export const absoluteFitMixin = css`
  position: absolute;
  inset: 0;
`;
